export default {"src":"/_next/static/media/risk-assessment-integration.57234474.svg","height":886,"width":748,"blurWidth":0,"blurHeight":0};